import {Component, OnInit} from '@angular/core';
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {LocaleSelectorComponent} from "@biletix/core/common/locale-selector.component";
import {I18nService} from "@biletix/core/services/i18n.service";
import {TranslateService} from "@ngx-translate/core";
import {Locale, Region} from "@biletix/core/common";
import {RegionService} from "@biletix/core/services/region.service";

@Component({
  standalone: false,
  selector: 'btx-artist-page',
  templateUrl: './artist-page.component.html',
  styleUrls: ['./artist-page.component.scss']
})
export class ArtistPageComponent extends LocaleSelectorComponent implements OnInit {

  locales: Locale[];
  currentLocale: Locale;
  regions: Region[];
  currentRegion: Region;


  constructor(
    private i18n: I18nService,
    private  region: RegionService,
    private translate: TranslateService) {
    super(translate, i18n);

    this.locales = this.i18n.getAvailableLocales();
            this.currentLocale = this.i18n.currentLocale;
            this.regions = this.region.getRegions();
            this.currentRegion = this.region.currentRegion;
  }

  ngOnInit(): void {
  }


}
